import { render, staticRenderFns } from "./expandableImage.vue?vue&type=template&id=42f9371e&"
import script from "./expandableImage.vue?vue&type=script&lang=js&"
export * from "./expandableImage.vue?vue&type=script&lang=js&"
import style0 from "./expandableImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports